document.addEventListener("DOMContentLoaded", () => {
  let processing = false;

  function getProductForm(target) {
    return target?.closest('form[action*="/cart/add"]') || target?.closest("form");
  }

  function getCheckbox(form) {
    // form-scoped first, then fallback
    return form?.querySelector('[data-gf-checkbox="true"]') || form?.querySelector("#gluten-free-checkbox");
  }

  function getGFVariantId(form) {
    // read from hidden input inside same form
    const fromInput = form?.querySelector('input[name="gf-addon-variant-id"]')?.value;
    const id = Number(fromInput);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function isGFEnabled(form) {
    const enabledInput = form?.querySelector('input[name="gf-enabled"]')?.value;
    return enabledInput === "1" || enabledInput === "true";
  }

  function getQty(form) {
    const fd = new FormData(form);
    const raw = fd.get("quantity") || form.querySelector('[name="quantity"]')?.value || 1;
    const qty = Number(raw);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getMainProductTitle(form) {
    const fromInput = form?.querySelector('input[name="product-title"]')?.value?.trim();
    if (fromInput) return fromInput;

    const fromHeading = form?.closest("[data-product-root], .product, .product-page")?.querySelector("h1.product__title, .product-title")?.textContent?.trim()
      || document.querySelector("h1.product__title, .product-title")?.textContent?.trim();
    if (fromHeading) return fromHeading;

    const fromBtn = form?.querySelector('button[name="add"], button[type="submit"]')?.getAttribute("data-product-title");
    if (fromBtn) return fromBtn.trim();

    return "Selected item";
  }

  function toggleDynamicCheckoutDisabled(form, disabled) {
    const dynamicWrap =
      form?.querySelector('[ref="acceleratedCheckoutButtonContainer"]') ||
      form?.querySelector(".shopify-payment-button");

    if (!dynamicWrap) return;
    dynamicWrap.style.pointerEvents = disabled ? "none" : "";
    dynamicWrap.style.opacity = disabled ? "0.45" : "";
    dynamicWrap.setAttribute("aria-disabled", disabled ? "true" : "false");
  }

  async function getCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    });
    return await res.json();
  }

  async function waitForMainAdd(beforeCount, expectedIncrease) {
    const target = beforeCount + expectedIncrease;
    for (let i = 0; i < 25; i++) {
      const cart = await getCart();
      const now = Number(cart.item_count || 0);
      if (now >= target) return true;
      await new Promise((r) => setTimeout(r, 120));
    }
    return false;
  }

  function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll("cart-items-component").forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  async function addGFAddon(gfVariantId, qty, parentTitle) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [
          {
            id: gfVariantId,
            quantity: qty,
            properties: {
              _addon_type: "Gluten-Free Upgrade",
              applied_to: parentTitle || "Selected item"
            }
          }
        ],
        sections: getCartSectionIds().join(",")
      })
    });

    const text = await res.text();
    let data;
    try { data = JSON.parse(text); } catch { data = text; }

    console.log("GF add status:", res.status, data);
    return { ok: res.ok, data };
  }

  function dispatchThemeCartAdd(cart, qtyAdded, sections) {
    const detail = {
      resource: cart,
      data: {
        source: "gluten-free-addon",
        itemCount: qtyAdded,
        sections: sections || {}
      }
    };

    document.dispatchEvent(new CustomEvent("cart:add", { detail, bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:add", { detail, bubbles: true }));

    document.dispatchEvent(new CustomEvent("cart:update", { detail: { resource: cart, data: { source: "gluten-free-addon" } }, bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent("ajaxCart:updated", { detail: { cart }, bubbles: true }));
  }

  // Disable Buy Now when GF checked (form-scoped)
  document.addEventListener("change", (event) => {
    const checkbox = event.target.closest('[data-gf-checkbox="true"], #gluten-free-checkbox');
    if (!checkbox) return;

    const form = getProductForm(checkbox);
    toggleDynamicCheckoutDisabled(form, checkbox.checked);
  }, true);

  // Handle add-to-cart click
  document.addEventListener("click", async (event) => {
    const addBtn = event.target.closest('button[name="add"], input[name="add"], button[type="submit"]');
    if (!addBtn || processing) return;

    const form = getProductForm(addBtn);
    if (!form) return;

    // only run where GF is enabled in THIS form
    if (!isGFEnabled(form)) return;

    const checkbox = getCheckbox(form);
    if (!checkbox?.checked) return;

    const gfVariantId = getGFVariantId(form);
    if (!gfVariantId) {
      console.warn("GF variant ID missing in form (input[name='gf-addon-variant-id'])");
      return;
    }

    const qty = getQty(form);
    const parentTitle = getMainProductTitle(form);

    processing = true;
    try {
      const before = await getCart();
      const beforeCount = Number(before.item_count || 0);

      // Let theme add main product first
      const mainAdded = await waitForMainAdd(beforeCount, qty);
      if (!mainAdded) {
        console.warn("GF: main add not detected in time");
        return;
      }

      const gf = await addGFAddon(gfVariantId, qty, parentTitle);
      if (!gf.ok) return;

      const cart = await getCart();
      dispatchThemeCartAdd(cart, qty, gf.data?.sections || {});

      const drawer = document.querySelector("cart-drawer-component");
      if (drawer && typeof drawer.open === "function") {
        drawer.open();
      } else {
        document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
      }
    } finally {
      setTimeout(() => { processing = false; }, 250);
    }
  }, true);
});